import * as ActionTypes from './ActionTypes';
import initialState from './InitialState';
import IFeatureState from '../../store/IFeatureState';
import { assign } from '../../shared/Assign';

export default function commonTextReducer(
    state: any = initialState.commonText,
    action: { type: string; result: any }
): any {
    let newState: IFeatureState;

    switch (action.type) {
        case ActionTypes.CREATE_COMMON_TEXT_SUCCESS:
            return {
                ...state,
                list: [...state.list, action.result]
            };
        case ActionTypes.LIST_COMMON_TEXT_SUCCESS:
            return {
                ...state,
                list: action.result
            };
        case ActionTypes.DELETE_COMMON_TEXT_SUCCESS:
            return {
                ...state,
                list: [...newState.list.filter((x: any) => x.id !== action.result)]
            };
        default:
            return state;
    }
}
